<template>
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- Grid cells -->
    <rect x="6" y="6" width="8" height="5" rx="1" fill="#666666" />
    <rect x="16" y="6" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="26" y="6" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="36" y="6" width="6" height="5" rx="1" fill="#D6D6D6" />
    <rect x="6" y="14" width="8" height="5" rx="1" fill="#666666" />
    <rect x="16" y="14" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="26" y="14" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="36" y="14" width="6" height="5" rx="1" fill="#D6D6D6" />
    <rect x="6" y="22" width="8" height="5" rx="1" fill="#666666" />
    <rect x="16" y="22" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="26" y="22" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="36" y="22" width="6" height="5" rx="1" fill="#D6D6D6" />
    <rect x="6" y="30" width="8" height="5" rx="1" fill="#666666" />
    <rect x="16" y="30" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="26" y="30" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="36" y="30" width="6" height="5" rx="1" fill="#D6D6D6" />
    <rect x="6" y="38" width="8" height="5" rx="1" fill="#666666" />
    <rect x="16" y="38" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="26" y="38" width="8" height="5" rx="1" fill="#D6D6D6" />
    <rect x="36" y="38" width="6" height="5" rx="1" fill="#D6D6D6" />
  </svg>
</template>
